import React, { type FC } from "react";

import CoreInputTextRight from "../../../../helpers/common/CoreInputText/components/Right/CoreInputTextRight";
import { useInputStore } from "../../../../helpers/common/CoreInputText/store/inputStore";
import { useCoreInputTextStore } from "../../../../helpers/common/CoreInputText/store/store";
import { ButtonInline } from "../../../ButtonInline";
import { createDisplayNameForInputTextElement } from "../../utils/getDisplayName";
import { createTestIdForInputTextElement } from "../../utils/getTestId";

import type {
    InputTextRightButtonInlineProps,
    InputTextRightProps,
} from "../../../../helpers/common/CoreInputText/types";
import type { Never } from "../../../../types/react";

const INPUT_TEXT_RIGHT_SHOW_HIDE_TEST_ID = createTestIdForInputTextElement(
    "button-inline-show-hide",
);

type InputTextRightShowHideOnClick = (
    e: React.MouseEvent,
    isVisible?: boolean,
) => void;

type InputTextRightShowHideProps = Omit<
    InputTextRightButtonInlineProps,
    "onClick"
> & {
    /** Выбираем контент, который будем отображать в ячейке */
    content: "showHide";
    inputType?: "password";
    /** aria-label для действия - показать пароль */
    showPassAriaLabel: string;
    /** aria-label для действия - спрятать пароль */
    hidePassAriaLabel: string;
    /** Обработчик клика по аддону Right. В варианте showHide из обработчика можно достать стейт isHiddenPass */
    onClick?: InputTextRightShowHideOnClick;
};

type IRightProps =
    | (InputTextRightShowHideProps &
          Never<InputTextRightProps, "clearInputAriaLabel" | "children">)
    | (InputTextRightProps &
          Never<
              InputTextRightShowHideProps,
              "showPassAriaLabel" | "hidePassAriaLabel"
          >);

export const Component: FC<IRightProps> = ({
    showPassAriaLabel,
    hidePassAriaLabel,
    ...props
}) => {
    const { state } = useCoreInputTextStore();
    const { onShowHide, isHiddenPass } = useInputStore();

    const { content, ...restProps } = props;

    if (content === "showHide") {
        return (
            <CoreInputTextRight content="custom">
                {content === "showHide" && (
                    <ButtonInline
                        {...restProps}
                        view="secondary"
                        onClick={(e) => {
                            onShowHide(e, props?.onClick);
                        }}
                        size="24"
                        state={state === "disabled" ? "disabled" : undefined}
                        aria-label={
                            isHiddenPass ? showPassAriaLabel : hidePassAriaLabel
                        }
                        data-tsid={INPUT_TEXT_RIGHT_SHOW_HIDE_TEST_ID}
                    >
                        <ButtonInline.RightIcon
                            icon={
                                isHiddenPass
                                    ? "glyph_view_off_24+"
                                    : "glyph_view_24+"
                            }
                        />
                    </ButtonInline>
                )}
            </CoreInputTextRight>
        );
    }

    // eslint-disable-next-line ok-custom-rules/check-attribute
    return <CoreInputTextRight {...props} />;
};

Component.displayName = createDisplayNameForInputTextElement("Right");

export default Component;
